<template>
  <b-modal id="modal-incidente-otro" size="md" :no-close-on-backdrop="true" :no-close-on-esc="true" v-model="mostrarModal" dialog-class="modal-dialog-scrollable" v-if="mostrarModal" @close="handleModalClose">
    <template slot="modal-title">
      <div>
        <span class="font-weight-light"><i class="la la-info-circle"></i> Detalle de incidente</span>
      </div>
    </template>
    <b-form id="frm-detalle-incidente-otro">
      <h5>{{ incidenteOtroModel.nombreLocalVotacion }}</h5>
      <h5>
        <small>{{ incidenteOtroModel.direccionLocalVotacion }}</small>
      </h5>
      <h5>
        <small class="text-muted">{{ incidenteOtroModel.nombreRegion }} / {{ incidenteOtroModel.nonbreSubRegion }}</small>
      </h5>
      <hr />
      <!--
      <div class="row pt-1">
        <div class="col-md-12">
          <label class="font-weight-bold">Local de Votación</label>
          <b-form-input id="input-3" v-model="incidenteOtroModel.nombreLocalVotacion" disabled placeholder=""></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Dirección</label>
          <b-form-input id="input-4" v-model="incidenteOtroModel.direccionLocalVotacion" disabled placeholder=""></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Región</label>
          <b-form-input id="input-5" v-model="incidenteOtroModel.nombreRegion" disabled placeholder=""></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Sub - Región</label>
          <b-form-input id="input-6" v-model="incidenteOtroModel.nonbreSubRegion" disabled placeholder=""></b-form-input>
        </div>
      </div>
      -->

      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Fecha y hora</label>
          <b-form-input id="input-7" v-model="horaEventoActo" disabled placeholder=""></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Caso</label>
          <b-form-input id="input-8" v-model="incidenteOtroModel.tipoIncidenteParamDescripcion" disabled placeholder=""></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Nro. Mesa</label>
          <b-form-input id="input-9" v-model="incidenteOtroModel.numeroMesa" disabled placeholder=""></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Intervención de autoridad</label>
          <b-form-input id="input-10" v-model="incidenteOtroModel.autoridadIntervencion" disabled placeholder=""></b-form-input>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Descripción del acto</label>
          <textarea class="form-control" ref="input-11" id="input-11" v-model="incidenteOtroModel.descripcionActo" disabled placeholder=""></textarea>
        </div>
      </div>
      <div class="row pt-3">
        <div class="col-md-12">
          <label class="font-weight-bold">Imagenes</label>
          <div v-if="incidenteOtroModel.imagenes">
            <CoolLightBox :items="incidenteOtroModel.coolboxImages" :index="incidenteOtroModel.coolboxIndex" :useZoomBar="true" :slideshow="true" @close="incidenteOtroModel.coolboxIndex = null"> </CoolLightBox>
            <div class="symbol-group symbol-hover" v-if="incidenteOtroModel.symbolImages.length > 0">
              <div v-for="(imagen, imageIndex) in incidenteOtroModel.symbolImages" :key="imagen.procesoElectoralMultimediaImagenId" @click="incidenteOtroModel.coolboxIndex = imageIndex">
                <div class="symbol symbol-50">
                  <img alt="" :src="apiResource(imagen.rutaArchivo)" />
                </div>
              </div>
              <div class="symbol symbol-50 symbol-circle symbol-light" v-if="incidenteOtroModel.masImagenes">
                <span class="symbol-label font-weight-bold" @click="incidenteOtroModel.coolboxIndex = 0">{{ incidenteOtroModel.masImagenes }}+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-form>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="handleModalClose()"><i class="fa fa-ban"></i> Cancelar</button>
    </template>
  </b-modal>
</template>

<style></style>

<script>
import moment from "moment";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  name: "modal-incidente-otro",
  components: { CoolLightBox },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    incidenteOtro: {
      type: Object,
    },
  },
  data: () => ({
    mostrarModal: true,
    incidenteOtroModel: {},
    horaEventoActo: null,
  }),
  computed: {},
  methods: {
    handleModalClose: async function(event) {
      if (event) {
        event.preventDefault();
      }
      this.mostrarModal = false;
    },
  },
  watch: {
    mostrarModal: function(newValue) {
      this.$emit("input", newValue);
    },
  },
  mounted: function() {
    this.mostrarModal = this.value;
    this.incidenteOtroModel = this.incidenteOtro;
    this.horaEventoActo = moment(String(this.incidenteOtroModel.horaEventoActo)).format("DD/MM/YYYY h:mm A");
  },
  destoyed: function() {},
};
</script>
